import reportsService from '@/modules/reports/services/reportsService';
import poll from '@/utils/poll';
import {
  ASYNC_POLL_INTERVAL_MS,
  ASYNC_POLL_MAX_RETRIES,
  REPORT_STATUSES,
} from '@/modules/reports/constants';

const state = {
  fields: {},
  savedFields: [],
  fieldsReportType: null,
};

const mutations = {
  setFields(state, value) {
    state.fields = value;
  },
  setSavedFields(state, value) {
    state.savedFields = value;
  },
  setFieldsReportType(state, value) {
    state.fieldsReportType = value;
  },
};

const actions = {
  async loadReportFields({ commit, state }, reportType) {
    commit('setFieldsReportType', reportType);
    commit('setFields', {});
    commit('setSavedFields', []);
    const response = await reportsService.fetchReportFields(reportType);
    // A dialog reopened for another report type has made a newer request
    if (state.fieldsReportType !== reportType) return;
    commit('setFields', response?.fields || {});
    commit('setSavedFields', response?.saved_fields || []);
  },

  // Returns the ready report, or null if the dialog was closed while polling.
  async generateReport(context, { payload, isCancelled = () => false }) {
    const created = await reportsService.createReport(payload);
    if (!payload.async_report) return created;

    let fetches = 0;
    const report = await poll(
      () => {
        fetches += 1;
        return reportsService.fetchReport(created.report_id);
      },
      (result) => isCancelled()
        || result?.status !== REPORT_STATUSES.PENDING
        || fetches > ASYNC_POLL_MAX_RETRIES,
      ASYNC_POLL_INTERVAL_MS,
    );

    if (isCancelled()) return null;
    if (report?.status !== REPORT_STATUSES.SUCCESS) {
      throw new Error(`Report ${created.report_id} was not generated`);
    }
    return report;
  },
};

const getters = {
  reportFields: (state) => state.fields,
  savedReportFields: (state) => state.savedFields,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
